<template>
 <div>
      {{ params.value.toLocaleString() }}
  </div>


</template>

<script>
export default {
  mounted() {
    // console.log("params", this.params);
  },
  methods: {},
    parseNumValue() {
      return this.params.value !== undefined &&this.params.value !== null ?
      this.params.value.toLocaleString()
       :
       "-"
    }
};
</script>
